module.exports = __webpack_public_path__ + "img/aspect-ratio-3-4-d.2b6d1c2b.svg";